import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/common/Headings.js";
import { SectionDescription } from "components/common/Typography.js";
import { Container, ContentWithPaddingXl } from "components/common/Layouts.js";
import { ReactComponent as ArrowRightIcon } from "images/arrow-right-icon.svg";
import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomizeIconImage from "images/customize-icon.svg";
import { ReactComponent as SvgDecoratorBlob3 } from "images/svg-decorator-blob-3.svg";

const Title = tw.h4`text-3xl font-bold text-gray-700 text-center pt-20`;
const SubTitle = tw.h4`mt-8 leading-relaxed font-bold text-lg`;
const Heading = tw(SectionHeading)``;
const Subheading = tw(SubheadingBase)`text-center mb-3`;
const Description = tw(SectionDescription)`text-center mx-auto`;
//const ThreeColumnContainer = styled.div`
//  ${tw`mt-10 flex flex-col items-center lg:items-stretch lg:flex-row flex-wrap lg:justify-center max-w-screen-lg mx-auto`}
//`;
const ThreeColumnContainer = styled.div`
  ${tw`flex flex-wrap -mx-1 overflow-hidden`}
`;
//const Column = styled.div`
//  ${tw`lg:w-1/3 max-w-xs`}
//`;
const Column = styled.div`
  ${tw`my-1 px-1 w-full overflow-hidden sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4`}
`;

const Card = styled.a`
  ${tw`flex flex-col items-center text-center h-full mx-4 px-4 py-8 rounded transition-transform duration-300 hover:cursor-pointer transform hover:scale-105 `}
  .imageContainer {
    ${tw`text-center rounded-full p-4 bg-gray-100`}
    img {
      ${tw`w-8 h-8`}
    }
  }

  .title {
    ${tw`mt-4 font-bold text-xl leading-none`}
  }

  .description {
    ${tw`mt-4 text-sm font-medium text-secondary-300`}
  }

  .link {
    ${tw`mt-auto inline-flex items-center pt-5 text-sm font-bold text-primary-300 leading-none hocus:text-primary-900 transition duration-300`}
    .icon {
      ${tw`ml-2 w-4`}
    }
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-40`}
`;

export default ({
  cards = [
    {
      imageSrc: ShieldIconImage,
      title: "Secure",
      description: "We strictly only deal with vendors that provide top notch security.",
      url: ""
    },
    {
      imageSrc: SupportIconImage,
      title: "24/7 Support",
      description: "Lorem ipsum donor amet siti ceali placeholder text",
      url: ""
    },
    {
      imageSrc: CustomizeIconImage,
      title: "Customizable",
      description: "Lorem ipsum donor amet siti ceali placeholder text",
      url: ""
    }
  ],
  linkText = "Learn More",
  heading = "",
  subheading = "",
  description = "",
  imageContainerCss = null,
  imageCss = null
}) => {
  /*
   * This componets accepts a prop - `cards` which is an array of object denoting the cards. Each object in the cards array can have the following keys (Change it according to your need, you can also add more objects to have more cards in this feature component):
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  4) url - the url that the card should goto on click
   */
  const Quote = tw.blockquote`text-center md:text-left font-medium text-xl lg:text-2xl xl:text-3xl`;
  return (
    //{/*<Container style={{backgroundColor:'rgb(229, 241, 255)',marginLeft:'-2rem',marginRight:'-2rem',marginTop:'-12em'}}>*/}
    <Container style={{ backgroundColor: 'rgb(229, 241, 255)', marginLeft: '-2rem', marginRight: '-2rem' }}>
      <ContentWithPaddingXl style={{ paddingTop: '0' }}>
        {subheading && <Subheading>{subheading}</Subheading>}
        {/*{heading && <Heading  >{heading}</Heading>}*/}
        <Title>{heading}</Title>
        {description && <Description>{description}</Description>}
        <ThreeColumnContainer className="homeUniqueThreeColumnContainer">
          {cards.map((card, i) => (
            <Column style={{ "borderRadius": "10px", "backgroundColor": "#FFFFFF", "boxShadow": "0 17px 34px 0 rgba(182,182,182,0.2)", "height": "260px", "width": "255px", "margin": "auto", marginTop: "1em" }} key={i}>
              <Card href={card.url}>
                <span className="imageContainer" style={{ "backgroundColor": "rgb(229, 241, 255)", "padding": "2.5rem" }}>
                  <img src={card.imageSrc} alt="" style={{ "width": "30px !important", "height": "27px !important" }} />
                </span>
                <SubTitle style={{ textAlign: "center" }}>{card.title}</SubTitle>
              </Card>
            </Column>
          ))}
        </ThreeColumnContainer>
      </ContentWithPaddingXl>
      <DecoratorBlob />
    </Container>
  );
};
